<template>
    <HLCardLayout :useFixedHeight="false" :scale="(isXsDevice)?1:(isXlDevice)?0.4:(isTabletOrPhone)?((isInLandscape)?0.9:0.7):0.7" :horizontalMargin="isLgAndUpDevice" :disablePadding="isXsDevice">
        <template #header-action>
            <!-- the only exit besides the buttons; never a link to /login while logged in -->
            <v-btn
                v-if="!disableLogout"
                class="mt-1 mb-sm-2 ml-n3"
                elevation="0"
                fab
                dark
                small
                @click.stop="navigateTo({ path: '/logout' })"
                color="rgba(0,0,0,0.8)"
            >
                <v-icon dark>mdi-logout</v-icon>
            </v-btn>
        </template>
        <template #content>
            <HLEasyEventSelection @next="onSelectedEvent" @list="goToEventList()"/>
        </template>
    </HLCardLayout>
</template>

<script>
import HLCardLayout from "../../components/dashboard/HLCardLayout";
import HLEasyEventSelection from "../../components/dashboard/HLEasyEventSelection";
import {layoutMixin} from "../../utils/layout-mixin";
import {settingsMixin} from "../../utils/settings-mixin";
import {eventMixin} from "../../utils/event-mixin";
import {qrLoginMixin} from "../../utils/qrlogin-mixin";
import {onboardingMixin} from "../../utils/onboarding-mixin";

export default {
    mixins: [layoutMixin,settingsMixin,eventMixin,qrLoginMixin,onboardingMixin],
    components:{
        HLCardLayout,
        HLEasyEventSelection
    },
    methods: {
        onSelectedEvent(id){
            this.goToEvent(id);
        }
    }
}
</script>

<style scoped>

.container{
    max-width: 600px;
}
</style>
